import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from '../app-config/app-config.service';

@Injectable({ providedIn: 'root' })
export class CashBoxUuidInterceptor implements HttpInterceptor {
  constructor(private readonly appConfigService: AppConfigService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const cashBoxUuid = this.appConfigService.getConfig()?.cashBoxUuid;

    if (cashBoxUuid && request.url.includes('/pos-api/')) {
      request = request.clone({
        params: request.params.set('cash_box_uuid', cashBoxUuid)
      });
    }

    return next.handle(request);
  }
}
